import research from "../../data/companyResearch20261006.json";

export function ResearchSources({ sources = [], label = "Sources for this section" }) {
  const unique = [...new Map(sources.map((item) => {
    const value = typeof item === "string" ? { url: item, label: new URL(item).hostname.replace(/^www\./, "") } : item;
    return [value.url, value];
  })).values()];
  return <div className="mt-4 border-t border-neutral-200 pt-3 text-xs leading-6 text-neutral-600"><p className="font-bold">{label}</p><div className="mt-1 flex flex-wrap gap-x-4 gap-y-1">{unique.map((item) => <a key={item.url} className="focus-ring break-words text-blue-700 underline underline-offset-2" href={item.url} target="_blank" rel="noopener noreferrer">{item.label}</a>)}</div></div>;
}

export function getCompanyResearch(company) {
  return research[company.id] || null;
}

const financeLabels = { revenue: "Revenue", funding: "Funding", valuation: "Valuation", transaction: "Acquisition", contract: "Contract value" };

export default function CompanyResearch({ company, headingLevel = 3 }) {
  const data = getCompanyResearch(company);
  if (!data) return null;
  const Heading = `h${Math.min(headingLevel, 6)}`;
  const missingFinance = [!data.finance?.some((item) => item.kind === "revenue") && "revenue", !data.finance?.some((item) => item.kind === "valuation") && "valuation"].filter(Boolean);
  return <div className="min-w-0 text-sm leading-7 text-neutral-700" data-company-research={company.id}>
    <Heading className="text-lg font-black text-neutral-950">Origins and founders</Heading>
    <dl className="mt-3 grid gap-3 sm:grid-cols-2">
      <div><dt className="font-bold text-neutral-950">Founding year</dt><dd>{data.founded || company.founded || "Not confirmed in this review"}</dd></div>
      <div><dt className="font-bold text-neutral-950">Founder information</dt><dd>{data.founders || "Not yet confirmed for this profile"}</dd></div>
    </dl>
    {data.foundingNote && <p className="mt-3 text-neutral-600">{data.foundingNote}</p>}
    {data.history && <p className="mt-3">{data.history}</p>}
    <Heading className="mt-5 text-lg font-black text-neutral-950">Technology and practical role</Heading>
    <p className="mt-2">{data.technology}</p>
    <Heading className="mt-5 text-lg font-black text-neutral-950">Financial information</Heading>
    {data.finance?.length > 0 && <div className="mt-3 grid gap-3">{data.finance.map((item) => <div key={`${item.kind}-${item.period}`} className="rounded-lg border border-neutral-200 p-3">
      <p className="font-bold text-neutral-950">{financeLabels[item.kind]} <span className="ml-2">{item.value}</span></p>
      <p>{item.period}. {item.scope}.</p><p className="text-xs text-neutral-600">{item.status}</p>
      {item.note && <p className="mt-1 text-xs leading-6 text-neutral-600">{item.note}</p>}
      <a className="focus-ring text-xs text-blue-700 underline" href={item.source.url} target="_blank" rel="noopener noreferrer">{item.source.label}</a>
    </div>)}</div>}
    {data.financeNote && <p className="mt-2 text-neutral-600">{data.financeNote}</p>}
    {!data.financeNote && missingFinance.length > 0 && <p className="mt-2 text-neutral-600">No {missingFinance.join(" or ")} figure has been verified for this profile. This is a gap in this directory, not a statement that the company has never published the information.</p>}
    <Heading className="mt-5 text-lg font-black text-neutral-950">What to check before a project</Heading>
    <p className="mt-2">{data.evaluation}</p>
    <ResearchSources sources={data.sources} />
    <p className="mt-2 text-xs text-neutral-500">Research additions reviewed <time dateTime={data.reviewedOn}>{data.reviewedOn}</time>. Historical figures retain their own reporting dates.</p>
  </div>;
}
